import React from "react";
import { Col, Container, Row } from "react-bootstrap";

const Error = ({ children }) => {
  return (
    <Container className="error">
      <Row>
        <Col>{children}</Col>
      </Row>
    </Container>
  );
};

export default Error;
